import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { notification, modal } from 'redux/modules/app'
import { fetchAward } from 'redux/modules/api/dashboard/awards'
import { residentialProject as residentialProjectApi } from 'redux/modules/api/combineDashboard'
import { schemaRPCompletion, schemaRPSetup } from 'models/residentialProjects'
import { schemaAlreadyAssessed, schemaApproval } from 'models/approvals'

function decorator(config = { loaders: [] }) {
  return ComposedComponent => {
    @connect(
      ({ api }) => {
        const loaders = {}

        config.loaders.forEach(key => {
          loaders[`${key}Status`] = get(
            api,
            `dashboard.residentialProject['${key}']`
          )
        })

        return {
          ...loaders,
          loading: get(api, 'dashboard.residentialProject.loading'),
          rPValues: get(api, 'dashboard.residentialProject')
        }
      },
      {
        ...residentialProjectApi,
        notification,
        fetchAward,
        modal,
        push
      }
    )
    class apiResidentialProject extends Component {
      static propTypes = {
        modal: PropTypes.func.isRequired,
        awardId: PropTypes.number,
        setupRP: PropTypes.func.isRequired,
        editRP: PropTypes.func.isRequired,
        fetchAward: PropTypes.func.isRequired,
        getRPDetail: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        completionRP: PropTypes.func.isRequired,
        getRPCategories: PropTypes.func.isRequired,
        sendLeaderRequest: PropTypes.func.isRequired,
        sendAssessmentRequest: PropTypes.func.isRequired,
        rpAssessorRejection: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        if (this.props.params.rPId && config.loadDetail === true) {
          this.handleGetRPDetail(Number(this.props.params.rPId))
        }
      }

      handleGetRPDetail = id => this.props.getRPDetail(id)

      handleGetRPCategories = () => this.props.getRPCategories()

      handleSetupRP = (id, fields, { resetForm }) => {
        this.props
          .setupRP(id, schemaRPSetup(fields))
          .then(() =>
            this.handleSuccess(
              'New residential project has been added',
              'notifications.new_residential_project_has_been_added',
              { resetForm }
            )
          )
          .catch(this.handleError)
      }

      handleEditRP = (id, fields, { resetForm }) =>
        this.props
          .editRP(id, schemaRPSetup(fields))
          .then(() =>
            this.handleSuccess(
              'Residential project has been updated',
              'notifications.residential_project_has_been_updated',
              { resetForm, id }
            )
          )
          .catch(this.handleError)

      handleCompletionRP = (id, fields, { resetForm }) =>
        this.props
          .completionRP(id, schemaRPCompletion(fields))
          .then(() => this.handleGetRPDetail(id))
          .then(() =>
            this.handleSuccess(
              'Residential project has been completed',
              'notifications.completion_residential_project_completed',
              { resetForm }
            )
          )
          .catch(this.handleError)

      handleSendAssessmentRequest = (id, fields, { resetForm }) =>
        this.props
          .sendAssessmentRequest(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Assessment request has been sent',
              'notifications.assessment_request_sent',
              { resetForm }
            )
          )
          .catch(this.handleError)

      handleSendAlreadyAssessed = (id, fields, { resetForm }) =>
        this.props
          .sendLeaderRequest(id, schemaAlreadyAssessed(fields))
          .then(() =>
            this.handleSuccess(
              'Leader approval request has been sent',
              'notifications.already_assessed_sent',
              { resetForm }
            )
          )
          .catch(this.handleError)

      handleSendLeaderRequest = (id, fields, { resetForm }) =>
        this.props
          .sendLeaderRequest(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Leader approval request has been sent',
              'notifications.leader_approval_sent',
              { resetForm }
            )
          )
          .catch(this.handleError)

      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        { resetForm, id = null }
      ) => {
        this.props.notification(text, { status: 'success', intlKey })
        this.props.modal(null, null)
        this.handleRefreshAward()
        id && this.handleGetRPDetail(id)
        resetForm && resetForm()
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleRefreshAward = () => {
        const { params, awardId } = this.props
        const id = params.awardId || awardId

        id && this.props.fetchAward(id, { fetchRP: true })
      }

      handleRpEventAssessorRejection = (rpId, fields) =>
        this.props
          .rpAssessorRejection(rpId, fields)
          .then(() =>
            this.props.notification('Residential project has been rejected', {
              status: 'success',
              intlKey: 'notifications.rp_has_been_rejected'
            })
          )
          .catch(this.handleError)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onSendAssessmentRequest={this.handleSendAssessmentRequest}
            onSendAlreadyAssessed={this.handleSendAlreadyAssessed}
            onSendLeaderRequest={this.handleSendLeaderRequest}
            onGetRPCategories={this.handleGetRPCategories}
            onCompletionRP={this.handleCompletionRP}
            onGetRPDetail={this.handleGetRPDetail}
            onSetupRP={this.handleSetupRP}
            onEditRP={this.handleEditRP}
            rpAssessorRejection={this.handleRpEventAssessorRejection}
          />
        )
      }
    }
    return apiResidentialProject
  }
}

export default decorator
